import React from "react";
import { Route, Routes } from "react-router-dom";

import Inicio from "./pages/Inicio";
import VerVideo from "./pages/VerVideo";
import SubirVideo from "./components/SubirVideo";
import Menu from "./components/Menu";
import Enviar from "./components/Enviar";

function App() {
  return (
    <div id="inicio">
      <Menu></Menu>
      <Enviar></Enviar>
      <Routes>
        <Route path="/" element={<Inicio />} />
        <Route path="/subir" element={<SubirVideo />} />
        <Route path="/:id" element={<VerVideo />} />
      </Routes>
    </div>
  );
}

export default App;
